if ($(".js-support-banner").length > 0) {
  window.onscroll = function (ev) {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 64
    ) {
      $(".js-support-banner").css("position", "relative");
    } else {
      $(".js-support-banner").css("position", "fixed");
    }
  };
}

$(function () {
  const cookies = document.cookie.split(";");
  const bannerHidden = cookies.find(
    (cookie) => cookie.split("=")[0].trim() === "bannerHidden"
  );

  !bannerHidden && $(".js-support-banner").show();
});

$(".js-support-banner .support-banner__close").on("click", function () {
  $(".js-support-banner").hide();
  document.cookie = "bannerHidden=true";
});
